const UserIcon = props => (
  <svg
    width={100}
    height={100}
    viewBox="0 0 100 100"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M50 50C62.9838 50 73.5 39.4838 73.5 26.5C73.5 13.5162 62.9838 3 50 3C37.0162 3 26.5 13.5162 26.5 26.5C26.5 39.4838 37.0162 50 50 50ZM50 61.75C34.3137 61.75 3 69.6225 3 85.25V97H97V85.25C97 69.6225 65.6863 61.75 50 61.75Z" />
  </svg>
)

export default UserIcon
